import { render, staticRenderFns } from "./MultiselectTagNew.vue?vue&type=template&id=208ed642&scoped=true"
import script from "./MultiselectTagNew.vue?vue&type=script&lang=ts"
export * from "./MultiselectTagNew.vue?vue&type=script&lang=ts"
import style0 from "./MultiselectTagNew.vue?vue&type=style&index=0&id=208ed642&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208ed642",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('208ed642')) {
      api.createRecord('208ed642', component.options)
    } else {
      api.reload('208ed642', component.options)
    }
    module.hot.accept("./MultiselectTagNew.vue?vue&type=template&id=208ed642&scoped=true", function () {
      api.rerender('208ed642', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/autocompleteMultiselects/MultiselectTagNew.vue"
export default component.exports